<template>
  <div class="myOrderBox">
    <!-- 标题box -->
    <div class="myOrderBox_title">{{ title }}</div>
    <div class="contractBox">
      <div style="font-size: 15px;">合同说明：</div>
      <div style="font-size: 14px;margin-top:10px;">1、申请合同后，系统将根据订单内容自动为您创建交易合同。</div>
      <div style="font-size: 14px;">2、签署方式为“仅供应商签署”生成的合同，带有乙方的电子签章，可直接下载线下邮寄签章使用；如您已开通电子签章服务，可选择“双方签署”生成合同，线上完成合同签署。</div>
      <div style="font-size: 14px;">3、如您联系平台“取消订单”，合同将自动失效。</div>
    </div>

    <!-- 主体box -->
    <el-form class="myOrderBox_main">
      <!-- 顶部导航栏 -->
      <!-- <div class="mainBox_nav">

      </div> -->
      <el-row>
        <el-col :span="8">
          <el-form-item label-width="80px" label="合同编号">
            <el-input v-model="queryParam.id"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="80px" label="下单时间">
            <el-date-picker  style="width: 100%;"
              v-model="dateRange"
              @change="changeDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <!-- <el-input v-model="queryParam.orderCreateTime"></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="80px" label="订单编号">
            <el-input v-model="queryParam.ordersn"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label-width="80px" label="签署状态">
            <el-select style="width: 100%;" v-model="queryParam.status" placeholder="请选择">
              <el-option label="全部" value=""> </el-option>
              <el-option label="待采购人签署" :value="3" > </el-option>
              <el-option label="签署完成" :value="4" > </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label-width="80px" label="合同金额">
            <div style="display: flex;justify-content: space-around;align-items: center;">
              <el-input style="width: 40%;" v-model="queryParam.amountMin"></el-input>
              <span>---</span>
              <el-input style="width: 40%;" v-model="queryParam.amountMax"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="80px" label="签署方式">
            <el-select style="width: 100%;" v-model="queryParam.signType" placeholder="请选择">
              <el-option label="全部" value=""> </el-option>
              <el-option label="双方签署" :value="1" > </el-option>
              <el-option label="仅供应商签署" :value="2" > </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="display: flex;justify-content: end;align-items: center;">
          <el-button type="primary" @click="getList(1)" >查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>

      </el-row>
    </el-form>

    <!-- 表头 -->
    <div class="mainBox_titleBox">
      <div style="width: 140px">合同编号</div>
      <div style="width: 180px">下单时间</div>
      <div style="width: 204px">订单编号</div>
      <div style="width: 150px">签署状态</div>
      <div style="width: 100px">签署方式</div>
      <div style="width: 150px">合同金额</div>
      <div style="width: 150px">操作</div>
    </div>
    <!-- 无数据替代 -->
    <el-empty description="暂无数据" v-if="orderList.length == 0"></el-empty>

    <!-- 订单列表 -->
    <div
      class="mainBox_orderList"
      v-for="(item, index) in orderList"
      :key="index"
    >
      <div class="orderList_main">
        <span style="width: 140px" class="mainSpan">
          {{item.id}}
        </span>
        <span style="width: 180px" class="mainSpan">
          {{item.orderCreateTime}}
        </span>

        <span style="width: 204px" class="mainSpan">
          {{item.ordersn}}
        </span>
        <div style="width: 150px; text-align: center">
          {{statusToStr(item.status)}}
        </div>
        <div style="width: 100px; text-align: center">
          {{item.signType == 1 ? '双方签署' : item.signType == 2? '仅供应商签署' : '未知'}}
        </div>
        <div style="width: 150px">
          {{item.orderPrice}}
        </div>
        <div class="btnBox" @click.stop="nothing()">
          <span v-if="item.orderStatus == -1" style="font-size: 12px;color:grey;">订单关闭，合同失效</span>

          <template v-else>
            <el-link
            v-if="item.signUrl"
              :underline="false"
              type="primary"
              style="font-size: 12px"
              @click.stop="signContract(item)"
              >签署电子合同</el-link
            >
            <el-link
              v-if="item.downloadSignUrl"
              :underline="false"
              type="primary"
              style="font-size: 12px"
              :href="item.downloadSignUrl"
              >下载合同</el-link
            >
          </template>
          
        </div>
      </div>
    </div>

    <!-- 底部分页 -->
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="current"
        layout=" prev, pager, next,total, jumper"
        :total="total"
        :page-size="limit"
      >
      </el-pagination>
    </div>

  </div>
</template>
<script>
import { postAction } from "../../../common/HttpHelper.js";
import { httpConfig } from "../../../common/config.js";
export default {
  name: 'contractManage',
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      dateRange: [],
      current: 1, //当前页数
      total: 0, //总条数
      amount: 0, //订单金额
      limit: 8, //每页显示几条
      orderList: [],
      queryParam:{
        id:'',
        status:'',
        ordersn:'',
        amountMin:'',
        amountMax:'',
        signType:'',
      },
    }
  },
  mounted() {
    this.getList(1, false); //获取订单列表
  },
  methods: {
    /**
     * 获取订单列表
     */
     getList(val) {

      if((this.queryParam.amountMin && !this.queryParam.amountMax)||(!this.queryParam.amountMin && this.queryParam.amountMax)){
        this.$message.error("合同金额请填写完整，或者全不填");
        return;
      }
      if(this.queryParam.amountMin && this.queryParam.amountMax){
        const regex = /^\d+(\.\d+)?$/;// 匹配正数和小数
        if (!regex.test(this.queryParam.amountMin) || !regex.test(this.queryParam.amountMax)) {
          this.$message.error("合同金额请输入数字");
          return;
        }
        if(this.queryParam.amountMin > this.queryParam.amountMax){
          this.$message.error("最小金额不能大于最大金额");
          return;
        }
        
      }
      const params = {};
      Object.assign(params, this.queryParam);
      params.current = val;
      var that = this;
      postAction(
        httpConfig.contractManage.getContractList,
        params,
        function (res) {
          if(res.flag){
            let data = res.data;
            that.orderList = JSON.parse(JSON.stringify(data.rows));
            that.total = data.total;
            that.amount = data.amount ? data.amount : 0;
            that.current = val;
          }
          
        },
        function (res) {}
      );
    },
    statusToStr(status){
      if(status == 0 || status == 1 || status == 2){
        return '供应商签署中';
      }else if(status == 3){
        return '待采购人签署';
      }else if(status == 4){
        return '签署完成';
      }else{
        return '签署失败';
      }
    },
    changeDate(dateArr) {
      if(!dateArr){
        this.queryParam.orderCreateTime = "";
        return;
      }
      let [beginDate,endDate] = dateArr;
      let beginStr = this.dateToStr(beginDate);
      let endStr = this.dateToStr(endDate);
      this.queryParam.orderCreateTime = beginStr + "~" + endStr;
      console.log(this.queryParam.orderCreateTime);
    },

    dateToStr(timeObj){
      var str = "";
      var year = timeObj.getFullYear();
      var month = timeObj.getMonth() + 1;
      var date = timeObj.getDate();
      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;
      str = year+"-"+month+"-"+date;
      console.log("------当前日期："+str);
      return str;
    },

    /**
     * 切换分页
     */
     handleCurrentChange(val) {
      //返回顶部
      this.getList(val);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },

    signContract(record){
      window.open(record.signUrl, '_blank');
    },
    reset(){
      this.queryParam = {
        id:'',
        status:'',
        ordersn:'',
        amountMin:'',
        amountMax:'',
        signType:'',
      };
      this.dateRange = [];
    },
  },
}

</script>
<style scoped>
.myOrderBox {
  display: flex;
  flex-direction: column;
}
.myOrderBox_title {
  width: 100%;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  color: #333333;
  margin-bottom: 20px;
}
.contractBox {
  width: 100%;
  /*height: 40px;
  line-height: 40px;*/
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;

  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
}
.myOrderBox_main {
  display: block;
  /*flex-direction: column;*/
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.mainBox_nav {
  width: 100%;
  height: 61px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
}
.mainBox_titleBox {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: flex;
  background-color: #ededed;

  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
  text-align: center;
}
.mainBox_orderList {
  width: 100%;
  height: 117px;
  box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.1);
  margin: 0 0 20px;
  display: flex;
  flex-direction: column;
}
.orderList_main {
  width: 100%;
  height: 117px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
  text-align: center;
}
.orderList_mainTitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /*width: 280px;*/
  height: 100%;
  color: #000;
  text-align: start;
  padding-left: 30px;
  box-sizing: border-box;
}
.btnBox {
  width: 150px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 15px 0;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/page/personal/contractManage/index.vue